module.exports = __webpack_public_path__ + "img/fork.90230056.png";